import { render, staticRenderFns } from "./TemporaryReservationCode.vue?vue&type=template&id=4cdbd36c&scoped=true&"
import script from "./TemporaryReservationCode.vue?vue&type=script&lang=js&"
export * from "./TemporaryReservationCode.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryReservationCode.vue?vue&type=style&index=0&id=4cdbd36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbd36c",
  null
  
)

export default component.exports